import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import defaultConfig from '../../config/configDefault';

const getImageVariantInfo = listingImageConfig => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } = listingImageConfig;
  const aspectRatio = aspectHeight / aspectWidth;
  const fieldsImage = [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`];

  return {
    fieldsImage,
    imageVariants: {
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    },
  };
};

export const fetchListing = createAsyncThunk(
  'PublishCheckoutPage/fetchListing',
  ({ id, config }, { dispatch, rejectWithValue, extra: sdk }) => {
    const layoutConfig = config || defaultConfig;
    const imageVariantInfo = getImageVariantInfo(layoutConfig.layout.listingImage);
    const queryParams = {
      include: ['author', 'images'],
      'fields.image': imageVariantInfo.fieldsImage,
      ...imageVariantInfo.imageVariants,
    };
    return sdk.ownListings
      .show({ id, ...queryParams })
      .then(response => {
        dispatch(addMarketplaceEntities(response));
        return response;
      })
      .catch(e => rejectWithValue(storableError(e)));
  }
);

const initialState = {
  listingId: null,
  fetchListingInProgress: false,
  fetchListingError: null,
};

const publishCheckoutPageSlice = createSlice({
  name: 'PublishCheckoutPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchListing.pending, state => {
        state.fetchListingInProgress = true;
        state.fetchListingError = null;
      })
      .addCase(fetchListing.fulfilled, (state, action) => {
        state.fetchListingInProgress = false;
        state.listingId = action.meta.arg.id;
      })
      .addCase(fetchListing.rejected, (state, action) => {
        state.fetchListingInProgress = false;
        state.fetchListingError = action.payload;
      });
  },
});

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const { id } = params;
  return dispatch(fetchListing({ id, config: defaultConfig }));
};

export default publishCheckoutPageSlice.reducer;
